export const TIME_SUCCESS_POST="TIME_SUCCESS_POST"
export const TIME_SUCCESS_GET="TIME_SUCCESS_GET"
export const TIME_SUCCESS_DELETE="TIME_SUCCESS_DELETE"